<template>
  <transition name="fade">
    <component :is="currentSlide" />
  </transition>
</template>

<script>
import { flashSettingsCollection } from '../../config/firebase';
const LeaderBoard = () => import(/* webpackChunkName: "leader-board" */ './LeaderBoard');
const VideoPlayer = () => import(/* webpackChunkName: "media-player" */ './VideoPlayer');
var timer;

export default {
  name: 'GalagaBoard',
  components: { LeaderBoard, VideoPlayer },
  data() {
    return {
      leaderboardDuration: 10,
      videoPlayerDuration: 160,
      currentSlide: '',
      flashSettings: []
    }
  },
  firestore: {
    flashSettings: flashSettingsCollection
  },
  watch: {
    shouldPlaySlide: {
      immediate: true,
      handler(status) {
        if (status)
          this.startSliding();
        else {
          this.currentSlide = LeaderBoard;
          clearTimeout(timer);
        }
      }
    }
  },
  computed: {
    shouldPlaySlide() {
      const defaultDoc = this.flashSettings[0];
      return defaultDoc ? defaultDoc.shouldPlaySlide : false;
    }
  },
  methods: {
    loadLeaderboard() {
      this.currentSlide = LeaderBoard;
      timer = setTimeout(() => {
        this.loadVideoPlayer();
      }, this.timeComputer(this.leaderboardDuration));
    },

    loadVideoPlayer() {
      this.currentSlide = VideoPlayer;
      timer = setTimeout(() => {
        this.loadLeaderboard();
      }, this.timeComputer(this.videoPlayerDuration));
    },

    startSliding() {
      this.loadLeaderboard();
    },

    timeComputer(duration) {
      return duration * 1000;
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>